<template>
    <div
        :class="[
            'rounded-[8px]',
            'border-solid',
            'border-1',
            'p-[8px_20px]',
            'text-14',
            'bg-transparent',
            'h-40px',
            'flex-center',
            'font-500',
            'cursor-pointer',
            isChangeStyle ? 'border-[#ffffff] text-[#ffffff]' : 'border-[#999999] text-[#333333]',
        ]"
        @click="login"
    >
        注册/登录
    </div>
</template>
<script setup lang="ts">
interface Props {
    isChangeStyle?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    isChangeStyle: undefined,
});

const route = useRoute();
const router = useRouter();
// 如果传入了 isChangeStyle prop，使用 prop；否则使用路由判断
const isChangeStyle = computed(() => {
    if (props.isChangeStyle !== undefined) {
        return props.isChangeStyle;
    }
    return route.path === '/home' || route.path?.indexOf('/home') >= 0;
});
const login = () => {
    router.push('/login');
};
</script>
